import ICommit from '@/store/contracts/commit'

const getDefaultState = () => {
    return {
        book: {},
        catalog: null,
        currentStage: 'bookCover',
        currentPage: 0,
        currentChapterData: null,
        currentChapter: null,
        bookHighlightData: null,
        bookAssessmentData: null,
        bookReadConf: {
            soundActive: false,
            sound: null,
        },
        epubPages: [],
        showIndex: false,
        showSettings: false,
        showQuestions: false,
        showHighlights: false,
        showMusic: false,
        showDictionary: false,
        showNotes: false,
        showReadaloud: false,
        questionsForChapter: [],
        itemsData: null,
        tipsData: null,
        indexItem: 0,
        itemType: null,
        currentQuestion: null,
        indexQuestion: 0,
        pendingTryAgain: false,
        pendingNextLot: false,
        hasQuestion: false,
        streak: 0,
        bookFavoriteForUser: false,
        word: '',
        dictionaryMode: '',
        bookCategories: [],
        bookUserNotes: [],
        idiomId: null,
        idiomParentId: null,
        showIdiomModal: false,
        trackIndex: 0,
        lastQuestionOfGroup: false,
        lastQuestionOfBook: false,
        isRecommended: false,
        bookRatingData: [],
        totalRatings: null,
        pageNumber: 0,
        pagesLoaded: 0,
        epubPagesLoaded: 0,
        readingTime: 0,
        readingTimeInterval: null,
        // Narrator
        activeNarration: false,
        pageAudio: null,
        bookPageVoices: [],
        currentVoice: null,
        mobileTools: {
            showIndex: false,
            showSettings: false,
            showQuestions: false,
            showHighlights: false,
            showMusic: false,
            showDictionary: false,
            showNotes: false,
            showReadaloud: false,
            showHeader: false,
        }
    }
}

const BookReading = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setBook: (state: any, value: any) => {
            state.book = value
        },
        setCatalog(state: any, value: any) {
            state.catalog = value
        },
        increaseCurrentPage(state: any) {
            state.currentPage += 1
        },
        decreaseCurrentPage(state: any) {
            state.currentPage -= 1
        },
        updateReadingTime(state: any, value: number) {
            state.readingTime = value
        },
        updateReadingTimeInterval(state: any, value: any) {
            state.readingTimeInterval = value
        },
        setActiveNarration(state: any, value = false) {
            state.activeNarration = value
        },
        setPageAudio(state: any, value = false) {
            state.pageAudio = value
        },
        setBookPageVoices(state: any, value: any) {
            state.bookPageVoices = value
        },
        setCurrentVoice(state: any, value: any) {
            state.currentVoice = value
        }
    },
    actions: {
        setBook({ commit }: ICommit, value: any) {
            commit('setBook', value)
        },
        setCatalog({ commit }: ICommit, value: any) {
            commit('setCatalog', value)
        },
        setHighlightData({ state }: any, value: any) {
            state.bookHighlightData = value
        },
        setBookAssessmentData({ state }: any, value: any) {
            state.bookAssessmentData = value
        },
        setCurrentPage({ state }: any, value: any) {
            state.currentPage = value
        },
        setCurrentChapter({ state }: any, value: any) {
            state.currentChapter = value
        },
        setBookReadConf({ state }: any, value: any) {
            state.bookReadConf = value
        },
        setSoundActive({ state }: any, value: any) {
            state.bookReadConf.soundActive = value
        },
        setCurrentStage({ state }: any, value: string) {
            state.currentStage = value
        },
        setCurrentChapterData({ state }: any, value: any) {
            state.currentChapterData = value
        },
        setBookCategories({ state }: any, value: any) {
            state.bookCategories = value
        },
        increaseCurrentPage({ commit }: ICommit) {
            commit('increaseCurrentPage')
        },
        decreaseCurrentPage({ commit }: ICommit) {
            commit('decreaseCurrentPage')
        },
        hideAllUtils({ state, rootState }: any) {
            if (rootState.isMobile) {
                state.mobileTools.showIndex = state.mobileTools.showSettings = state.mobileTools.showQuestions = state.mobileTools.showHighlights = state.mobileTools.showMusic = state.mobileTools.showDictionary = state.mobileTools.showNotes = state.mobileTools.showReadaloud = false
                return
            }
            state.showSettings = state.showIndex = state.showQuestions = state.showHighlights = state.showMusic = state.showDictionary = state.showNotes = state.showReadaloud = false
        },
        showIndex({ state, rootState }: any) {
            if (rootState.isMobile) {
                state.mobileTools.showSettings = state.mobileTools.showQuestions = state.mobileTools.showHighlights = state.mobileTools.showMusic = state.mobileTools.showDictionary = state.mobileTools.showNotes = state.mobileTools.showReadaloud = false
                state.mobileTools.showIndex = !state.mobileTools.showIndex
                return
            }
            state.showSettings = state.showQuestions = state.showHighlights = state.showMusic = state.showDictionary = state.showNotes = state.showReadaloud = false
            state.showIndex = !state.showIndex
        },
        showSettings({ state, rootState }: any) {
            if (rootState.isMobile) {
                state.mobileTools.showIndex = state.mobileTools.showQuestions = state.mobileTools.showHighlights = state.mobileTools.showMusic = state.mobileTools.showDictionary = state.mobileTools.showNotes = state.mobileTools.showReadaloud = false
                state.mobileTools.showSettings = !state.mobileTools.showSettings
                return
            }
            state.showIndex = state.showQuestions = state.showHighlights = state.showMusic = state.showDictionary = state.showNotes = state.showReadaloud = false
            state.showSettings = !state.showSettings
        },
        showQuestions({ state, rootState }: any) {
            if (rootState.isMobile) {
                state.mobileTools.showIndex = state.mobileTools.showSettings = state.mobileTools.showHighlights = state.mobileTools.showMusic = state.mobileTools.showDictionary = state.mobileTools.showNotes = state.mobileTools.showReadaloud = false
                state.mobileTools.showQuestions = !state.mobileTools.showQuestions
                return
            }
            state.showIndex = state.showSettings = state.showHighlights = state.showMusic = state.showDictionary = state.showNotes = state.showReadaloud = false
            state.showQuestions = !state.showQuestions
        },
        showHighlights({ state, rootState }: any) {
            if (rootState.isMobile) {
                state.mobileTools.showIndex = state.mobileTools.showSettings = state.mobileTools.showQuestions = state.mobileTools.showMusic = state.mobileTools.showDictionary = state.mobileTools.showNotes = state.mobileTools.showReadaloud = false
                state.mobileTools.showHighlights = !state.mobileTools.showHighlights
                return
            }
            state.showIndex = state.showSettings = state.showQuestions = state.showMusic = state.showDictionary = state.showNotes = state.showReadaloud = false
            state.showHighlights = !state.showHighlights
        },
        showMusic({ state, rootState }: any) {
            if (rootState.isMobile) {
                state.mobileTools.showIndex = state.mobileTools.showSettings = state.mobileTools.showQuestions = state.mobileTools.showHighlights = state.mobileTools.showDictionary = state.mobileTools.showNotes = state.mobileTools.showReadaloud = false
                state.mobileTools.showMusic = !state.mobileTools.showMusic
                return
            }
            state.showIndex = state.showSettings = state.showQuestions = state.showHighlights = state.showDictionary = state.showNotes = state.showReadaloud = false
            state.showMusic = !state.showMusic
        },
        showDictionary({ state, rootState }: any) {
            console.log('showDictionary', state.mobileTools.showDictionary, state.showDictionary)
            if (rootState.isMobile) {
                state.mobileTools.showIndex = state.mobileTools.showSettings = state.mobileTools.showQuestions = state.mobileTools.showHighlights = state.mobileTools.showMusic = state.mobileTools.showNotes = state.mobileTools.showReadaloud = false
                state.mobileTools.showDictionary = !state.mobileTools.showDictionary
                return
            }
            state.showIndex = state.showSettings = state.showQuestions = state.showHighlights = state.showMusic = state.showNotes = state.showReadaloud = false
            state.showDictionary = !state.showDictionary
        },
        showNotes({ state, rootState }: any) {
            if (rootState.isMobile) {
                state.mobileTools.showIndex = state.mobileTools.showSettings = state.mobileTools.showQuestions = state.mobileTools.showHighlights = state.mobileTools.showMusic = state.mobileTools.showDictionary = state.mobileTools.showReadaloud = false
                state.mobileTools.showNotes = !state.mobileTools.showNotes
                return
            }
            state.showIndex = state.showSettings = state.showQuestions = state.showHighlights = state.showMusic = state.showDictionary = state.showReadaloud = false
            state.showNotes = !state.showNotes
        },
        showReadaloud({ state, rootState }: any) {
            if (rootState.isMobile) {
                state.mobileTools.showIndex = state.mobileTools.showSettings = state.mobileTools.showQuestions = state.mobileTools.showHighlights = state.mobileTools.showMusic = state.mobileTools.showDictionary = state.mobileTools.showNotes = false
                state.mobileTools.showReadaloud = !state.mobileTools.showReadaloud
                return
            }
            state.showIndex = state.showSettings = state.showQuestions = state.showHighlights = state.showMusic = state.showDictionary = state.showNotes = false
            state.showReadaloud = !state.showReadaloud
        },
        setBookFontFamily({ state }: any, value: any) {
            state.bookReadConf.fontFamily = value
        },
        setBookFontSize({ state }: any, value: any) {
            state.bookReadConf.fontSize = value
        },
        setBookReadSound({ state }: any, value: any) {
            state.bookReadConf.sound = value
        },
        //Preguntas
        setQuestionForChapter({ state }: any, value: any) {
            state.questionsForChapter = value
        },
        setItemsData({ state }: any, value: any) {
            state.itemsData = value
        },
        setTipsData({ state }: any, value: any) {
            state.tipsData = value
        },
        setIndexItem({ state }: any, value: any) {
            state.indexItem = value
        },
        setItemType({ state }: any, value: any) {
            state.itemType = value
        },
        setCurrentQuestion({ state }: any, value: any) {
            state.currentQuestion = value
        },
        setIndexQuestion({ state }: any, value: any) {
            state.indexQuestion = value
        },
        setPendingTryAgain({ state }: any, value: any) {
            state.pendingTryAgain = value
        },
        setPendingNextLot({ state }: any, value: any) {
            state.pendingNextLot = value
        },
        setHasQuestion({ state }: any, value: any) {
            state.hasQuestion = value
        },
        setStreak({ state }: any, value: any) {
            state.streak = value
        },
        spliceHighlight({ state }: any, value: any) {
            const index = state.bookHighlightData.indexOf(value)
        },
        setBookFavoriteForUserValue({ state }: any, value: any) {
            state.bookFavoriteForUser = value
        },
        setBookFavoriteForUser({ state }: any) {
            state.bookFavoriteForUser = !state.bookFavoriteForUser
        },
        //Dictionary
        setWord({ state }: any, word: any) {
            state.word = word
        },
        setDictionaryMode({ state }: any, value: any) {
            state.dictionaryMode = value
        },
        //Notes
        setBookUserNotes({ state }: any, value: any) {
            state.bookUserNotes = value
        },
        //reset state
        resetBookReadingState({ state }: any) {
            Object.assign(state, getDefaultState())
        },
        //        epub
        setEpubPages({ state }: any, value: any) {
            state.epubPages = value
        },
        //Linguistic Variables
        resetIdioms({ state }: any) {
            state.idiomId = state.idiomParentId = null
            state.showIdiomModal = false
        },
        setIdiomId({ state }: any, value: any) {
            state.idiomId = value
        },
        setIdiomParentId({ state }: any, value: any) {
            state.idiomParentId = value
        },
        showIdiomModal({ state }: any, value: any) {
            state.showIdiomModal = value
        },
        setTrackIndex({ state }: any, value: any) {
            state.trackIndex = value
        },
        //Para logros
        setLastQuestionOfGroup({ state }: any, value: any) {
            state.lastQuestionOfGroup = value
        },
        setLastQuestionOfBook({ state }: any, value: any) {
            state.lastQuestionOfBook = value
        },
        setRecommended({ state }: any, value: any) {
            state.isRecommended = value
        },
        setBookRatingData({ state }: any, value: any) {
            state.bookRatingData = value
        },
        concatBookRatingData({ state }: any, value: any) {
            if (!state.bookRatingData.length) state.bookRatingData = value
            else state.bookRatingData = state.bookRatingData.concat(value)
        },
        setPageNumber({ state }: any, value: any) {
            state.pageNumber = value
        },
        increasePageNumber({ state }: any) {
            state.pageNumber += 1
        },
        setTotalRating({ state }: any, value: any) {
            state.totalRatings = value
        },
        increasePagesLoaded({ state }: any) {
            state.pagesLoaded += 1
        },
        increaseEpubPagesLoaded({ state }: any) {
            state.epubPagesLoaded += 1
        },
        updateReadingTime({ commit }: ICommit, value: number) {
            commit('updateReadingTime', value)
        },
        updateReadingTimeInterval({ commit }: ICommit, value: any) {
            commit('updateReadingTimeInterval', value)
        },
        setActiveNarration({commit}: ICommit, value = false){
            commit('setActiveNarration', value)
        },
        setPageAudio({commit}: ICommit, value = false) {
            commit('setPageAudio', value)
        },
        setBookPageVoices({commit}: any, value: any) {
            commit('setBookPageVoices', value)
        },
        setCurrentVoice({commit}: any, value: any) {
            commit('setCurrentVoice', value)
        }
    },
}

export default BookReading
